module.exports = __webpack_public_path__ + "static/banco_de_es_logo-0fe785b89f5fd3decfe9d585dbde8150.svg";